export const TESTFLIGHT_URL = 'https://testflight.apple.com/join/s3kVuZ7x';
export const APP_STORE_URL = 'https://apps.apple.com/app/rost-and-found/id6744145937';

/** Set to true when publishing to the App Store */
export const IS_PRODUCTION = false;

export const DOWNLOAD_URL = IS_PRODUCTION ? APP_STORE_URL : TESTFLIGHT_URL;

export const PRIVACY_URL = 'https://rostandfound.app/privacy.html';
export const TERMS_URL = 'https://rostandfound.app/terms.html';
export const SUPPORT_URL = 'https://rostandfound.app/support.html';
